import React from 'react'
import './Footer.css'

function Footer() {
	return (
		<div className='footer'>
			<p> © This is a my take on an Airbnb clone!
			No rights reserved - this is a demo! </p>
			<p> Privacy | Terms | Sitemap | Company Details </p>
		</div>
	)
}

export default Footer